module.exports = __webpack_public_path__ + "static/1_1_defineai_PT-1e5bbbcf6c2b7cfe1f6d38cde674ff5d.svg";